import * as React from 'react';
import { ReactNode } from 'react';
import * as R from 'ramda';
import { ResortToolsConfig } from './config/resortToolsConfig';
import ConfigView from './ConfigView';


type Props = {
  children: React.ReactNode | null;
  configPath: string | string[];
  secondaryConfigPath?: string |[];
  config?: ResortToolsConfig;
  userRole?: string | undefined;
};

/**
 * ConfigHide: a component that takes a property path through ResortToolsConfig and renders/doesn't render its children
 * based on if the config value at the given path is an array including the current user's role OR if that value is
 * truthy and not an array.
 *
 * Connected to Redux: false
 */
export default ConfigView(((props: Props): ReactNode => {
  const path    = ([] as string[]).concat(props.configPath);
  const value: string[] | undefined  = R.path(path, props.config);
  const role    = props.userRole;
  const isArray = Array.isArray(value);

  if (value && !value.length && props.secondaryConfigPath){
    const secondaryPath = ([] as string[]).concat(props.secondaryConfigPath);
    const secondaryValue: string[] | undefined  = R.path(secondaryPath, props.config);
    const isArraySecond = Array.isArray(secondaryValue);
    return (isArraySecond && R.includes(role, secondaryValue as [])) || (!isArraySecond && !!secondaryValue) ? props.children : null;
  }

    return (isArray && R.includes(role, value as [])) || (!isArray && !!value) ? props.children : null;


  // Config value is an array containing the user's role or value is truthy, show children

}) as unknown as any);
